import { useCallback } from 'react'
import { twMerge } from 'tailwind-merge'
import { type SearchCriteria, useAppliedSearchCriteria } from '~/features/search/criteria'
import { useCommitKeyword } from '~/features/search/sd'
import { useReserveNavigate } from '~/navigation'
import { Button } from '~/ui'

export function ApplyButton({
  className,
  useApply,
}: { className?: string; useApply: () => (criteria: SearchCriteria) => void }) {
  const apply = useApply()
  const commitKeyword = useCommitKeyword()
  const onClick = useCallback(() => {
    const criteria = commitKeyword()
    apply(criteria ?? {})
  }, [apply, commitKeyword])
  return (
    <div className={twMerge('w-full p-3', className)}>
      <Button onClick={onClick} color="secondary" spread>
        決定する
      </Button>
    </div>
  )
}

// エリア・ジャンル・絞り込み条件を適用する際のカスタムフック
// 人数日時の条件は元の条件を引き継ぐ
export function useApplySearchCriteria() {
  const navigate = useReserveNavigate()
  const applied = useAppliedSearchCriteria()
  return useCallback(
    ({ visitDate, visitorsCount, visitTime, ...criteria }: SearchCriteria) => {
      navigate({
        type: 'searchCriteriaSubmitted',
        ...criteria,
        visitDate: applied?.visitDate,
        visitorsCount: applied?.visitorsCount,
        visitTime: applied?.visitTime,
      })
    },
    [applied, navigate]
  )
}

// 人数日時を適用する際のカスタムフック
// エリア・ジャンル・絞り込み条件は元の条件を引き継ぐ
export function useApplyCalendar() {
  const navigate = useReserveNavigate()
  const applied = useAppliedSearchCriteria()
  return useCallback(
    (criteria: SearchCriteria) => {
      navigate({
        type: 'searchCriteriaSubmitted',
        ...applied,
        visitDate: criteria.visitDate,
        visitorsCount: criteria.visitorsCount,
        visitTime: criteria.visitTime,
      })
    },
    [applied, navigate]
  )
}
